import ProjectOffersGrid from './project-offers-grid';
export default ProjectOffersGrid;